export enum OrderPaymentState {
  STATE_CART = 'cart',
  STATE_AWAITING_PAYMENT = 'awaiting_payment',
  STATE_FAILED = 'failed',
  STATE_PAID = 'paid',
}
